export interface City {
  id: number;
  name: string;
}

export interface Country {
  id: number;
  name: string;
  cities: City[];
}

export const countries: Country[] = [
  {
    id: 1,
    name: 'Srbija',
    cities: [
      { id: 101, name: 'Beograd' },
      { id: 102, name: 'Novi Sad' },
      { id: 103, name: 'Niš' },
      { id: 104, name: 'Kragujevac' },
      { id: 105, name: 'Subotica' },
      { id: 106, name: 'Zrenjanin' },
      { id: 107, name: 'Pančevo' },
      { id: 108, name: 'Čačak' },
      { id: 109, name: 'Kruševac' },
      { id: 110, name: 'Kraljevo' },
      { id: 111, name: 'Smederevo' },
      { id: 112, name: 'Vranje' },
      { id: 113, name: 'Šabac' },
      { id: 114, name: 'Sombor' },
      { id: 115, name: 'Požarevac' },
      { id: 116, name: 'Pirot' },
      { id: 117, name: 'Zaječar' },
      { id: 118, name: 'Jagodina' },
      { id: 119, name: 'Vršac' },
      { id: 120, name: 'Užice' },
      { id: 121, name: 'Leskovac' },
      { id: 122, name: 'Valjevo' },
      { id: 123, name: 'Sremska Mitrovica' },
      { id: 124, name: 'Loznica' },
      { id: 125, name: 'Bečej' },
      { id: 126, name: 'Prokuplje' },
      { id: 127, name: 'Senta' },
      { id: 128, name: 'Aranđelovac' },
      { id: 129, name: 'Inđija' },
      { id : 130, name: 'Raška' },
      { id: 131, name: 'Vrbas' }
    ]
  },
  {
    id: 2,
    name: 'Hrvatska',
    cities: [
      { id: 201, name: 'Zagreb' },
      { id: 202, name: 'Split' },
      { id: 203, name: 'Rijeka' },
      { id: 204, name: 'Osijek' },
      { id: 205, name: 'Zadar' },
      { id: 206, name: 'Pula' },
      { id: 207, name: 'Slavonski Brod' },
      { id: 208, name: 'Karlovac' },
      { id: 209, name: 'Varaždin' },
      { id: 210, name: 'Šibenik' },
      { id: 211, name: 'Sisak' },
      { id: 212, name: 'Velika Gorica' },
      { id: 213, name: 'Vinkovci' },
      { id: 214, name: 'Vukovar' },
      { id: 215, name: 'Dubrovnik' },
      { id: 216, name: 'Bjelovar' },
      { id: 217, name: 'Koprivnica' },
      { id: 218, name: 'Križevci' },
      { id: 219, name: 'Đakovo' },
      { id: 220, name: 'Požega' },
      { id: 221, name: 'Zaprešić' },
      { id: 222, name: 'Solin' },
      { id: 223, name: 'Kaštela' },
      { id: 224, name: 'Samobor' },
      { id: 225, name: 'Virovitica' },
      { id: 226, name: 'Kutina' },
      { id: 227, name: 'Pazin' },
      { id: 228, name: 'Rovinj' },
      { id: 229, name: 'Poreč' },
      { id: 230, name: 'Umag' }
    ]
  },
  {
    id: 3,
    name: 'Bosna i Hercegovina',
    cities: [
      { id: 301, name: 'Sarajevo' },
      { id: 302, name: 'Banja Luka' },
      { id: 303, name: 'Tuzla' },
      { id: 304, name: 'Zenica' },
      { id: 305, name: 'Bihać' },
      { id: 306, name: 'Mostar' },
      { id: 307, name: 'Prijedor' },
      { id: 308, name: 'Doboj' },
      { id: 309, name: 'Zavidovići' },
      { id: 310, name: 'Bijeljina' },
      { id: 311, name: 'Trebinje' },
      { id: 312, name: 'Travnik' },
      { id: 313, name: 'Brčko' },
      { id: 314, name: 'Bugojno' },
      { id: 315, name: 'Goražde' },
      { id: 316, name: 'Gradiška' },
      { id: 317, name: 'Jajce' },
      { id: 318, name: 'Kakanj' },
      { id: 319, name: 'Konjic' },
      { id: 320, name: 'Livno' },
      { id: 321, name: 'Lukavac' },
      { id: 322, name: 'Modriča' },
      { id: 323, name: 'Neum' },
      { id: 324, name: 'Novi Travnik' },
      { id: 325, name: 'Odžak' },
      { id: 326, name: 'Sanski Most' },
      { id: 327, name: 'Srebrenica' },
      { id: 328, name: 'Teslić' },
      { id: 329, name: 'Tomislavgrad' },
      { id: 330, name: 'Visoko' }
    ]
  },
  {
    id: 4,
    name: 'Crna Gora',
    cities: [
      { id: 401, name: 'Podgorica' },
      { id: 402, name: 'Nikšić' },
      { id: 403, name: 'Herceg Novi' },
      { id: 404, name: 'Bar' },
      { id: 405, name: 'Bijelo Polje' },
      { id: 406, name: 'Cetinje' },
      { id: 407, name: 'Budva' },
      { id: 408, name: 'Berane' },
      { id: 409, name: 'Ulcinj' },
      { id: 410, name: 'Tivat' },
      { id: 411, name: 'Rožaje' },
      { id: 412, name: 'Danilovgrad' },
      { id: 413, name: 'Kotor' },
      { id: 414, name: 'Mojkovac' },
      { id: 415, name: 'Pljevlja' },
      { id: 416, name: 'Žabljak' },
      { id: 417, name: 'Andrijevica' },
      { id: 418, name: 'Gusinje' },
      { id: 419, name: 'Plav' },
      { id: 420, name: 'Petnjica' }
    ]
  },
  {
    id: 5,
    name: 'Makedonija',
    cities: [
      { id: 501, name: 'Skopje' },
      { id: 502, name: 'Bitola' },
      { id: 503, name: 'Kumanovo' },
      { id: 504, name: 'Prilep' },
      { id: 505, name: 'Tetovo' },
      { id: 506, name: 'Veles' },
      { id: 507, name: 'Štip' },
      { id: 508, name: 'Ohrid' },
      { id: 509, name: 'Gostivar' },
      { id: 510, name: 'Strumica' },
      { id: 511, name: 'Kavadarci' },
      { id: 512, name: 'Kočani' },
      { id: 513, name: 'Kičevo' },
      { id: 514, name: 'Struga' },
      { id: 515, name: 'Radoviš' },
      { id: 516, name: 'Gevgelija' },
      { id: 517, name: 'Delčevo' },
      { id: 518, name: 'Vinica' },
      { id: 519, name: 'Resen' },
      { id: 520, name: 'Probištip' },
      { id: 521, name: 'Kriva Palanka' },
      { id: 522, name: 'Negotino' },
      { id: 523, name: 'Sveti Nikole' },
      { id: 524, name: 'Debar' },
      { id: 525, name: 'Kratovo' }
    ]
  }
];

export const getCitiesByCountry = (countryId: number): City[] => {
  const country = countries.find(c => c.id === countryId);
  return country ? country.cities : [];
}; 